import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24.95 24.166a12.034 12.034 0 0 1-5.033 3.375l-.12.041c-.66.21-1.762.418-2.436.418-.642 0-2.549-.176-4.258-1.19-1.638-.974-3.157-2.744-3.157-6.145 0-1.228.261-2.857.978-4.164.253-.46.558-.876.93-1.223a4.243 4.243 0 0 0-.076.752v.01c0 4.988 4.805 8.589 9.96 8.59 1.088.001 2.17-.155 3.212-.464Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.047 22.44c.259 1.322.8 2.57 1.587 3.658a9.07 9.07 0 0 0 1.163 1.343 12.05 12.05 0 0 1-6.66-6.197A12.41 12.41 0 0 1 4 15.943v-.009c0-1.56.778-3.325 2.112-4.714 1.326-1.38 3.113-2.297 5.024-2.297 2.532 0 4.174.486 5.234 1.128 1.043.631 1.588 1.453 1.872 2.272.027.078.052.156.074.233a4.248 4.248 0 0 0-2.304-.705c-.923-.016-1.626.32-1.958.48l-.048.023-.015.007a9.184 9.184 0 0 0-3.094 2.5 9.274 9.274 0 0 0-1.757 3.584 9.318 9.318 0 0 0-.093 3.996Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.363 19.401c-.787-.085-1.58-.27-2.101-.593.601-.801.97-1.806.97-2.607 0-.615-.115-2.2-.87-3.514-.68-1.184-1.674-2.39-3.521-3.367-2.097-1.11-4.319-1.143-4.716-1.143-1.921 0-3.769.54-5.29 1.477a12.084 12.084 0 0 1 1.73-2.17A11.954 11.954 0 0 1 15.994 4c4.752 0 9.01 2.292 10.962 6.138l.053.106c.354.698 1.013 1.999.99 3.925v.01a5.323 5.323 0 0 1-.699 2.628 5.269 5.269 0 0 1-1.902 1.93l-.006.003a5.03 5.03 0 0 1-2.573.716h-.028a10.2 10.2 0 0 1-1.428-.055Z",
      clipRule: "evenodd"
    }
  )
);
var SvgEdgeFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var EdgeFilled_default = SvgEdgeFilled;

export { EdgeFilled_default as default };
